import type { FC } from "react";

import classNames from "classnames";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";

import styles from "./ContainerHeader.module.scss";

export type ContainerHeaderProps = {
  title?: string;
  ctaLabel?: string;
  ctaHref?: string;
};

export const ContainerHeader: FC<ContainerHeaderProps> = ({ ctaHref, ctaLabel, title }) => {
  const buttonCommonProps = {
    href: ctaHref ?? "",
    variant: "text-muted",
    iconAfter: LongArrowForwardIcon,
  } as const;

  const isTitleHidden = !title;
  const isLinkHidden = !ctaHref || !ctaLabel;

  if (isTitleHidden && isLinkHidden) {
    return null;
  }

  return (
    <div
      className={classNames(styles.headingWrapper, {
        [styles.withLinkOnly]: isTitleHidden,
      })}
    >
      {!isTitleHidden && <span className={styles.title}>{title}</span>}
      {!isLinkHidden && (
        <div
          className={classNames(styles.buttonWrapper, {
            [styles.positionReset]: isTitleHidden,
          })}
        >
          <Button {...buttonCommonProps} className={styles.desktopButton} size="lg">
            {ctaLabel}
          </Button>
          <Button {...buttonCommonProps} className={styles.mobileButton} size="sm">
            {ctaLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
